export default __webpack_public_path__ + "static/media/magic.b3a3ab2f.mp3";